const ru = {
  mainTitle: "Регистрация на экзамен",
  selectExam: "Выберите экзамен",
  selectVenue: "Выберите место",
  selectModule: "Выберите модуль",
  selectTestDate: "Выберите желаемую дату теста",
  fillDetails: "Пожалуйста, заполните данные ниже:",
  residenceCountry: "Страна проживания",
  Other: "Другое",
  Uzbekistan: "Узбекистан",
  passportNo: "Номер паспорта или ID (нп. AA1234567)",
  invalidPassportNo: "Пожалуйста, введите правильный номер паспорта или ID.",
  pinpp: "ПИНФЛ (14 цифр)",
  invalidPinpp: "Пожалуйста, введите правильный 14-значный ПИНФЛ.",
  pinppLookupError:
    "Не удалось получить информацию по ПИНФЛ, пожалуйста, проверьте",
  dob: "Дата рождения",
  wrongPassportOrDob:
    "Неправильный номер паспорта или дата рождения, проверьте",
  proceed: "Продолжить",
  firstName: "Имя (на паспорте)",
  lastName: "Фамилия (на паспорте)",
  gender: "Пол",
  male: "Мужской",
  female: "Женский",
  selectCertificateRegion: "Выберите регион, который вы получаете сертификат:",
  phoneNumber: "Номер телефона (включая 998)",
  invalidPhoneNumber: "Пожалуйста, введите правильный номер телефона.",
  email: "Email",
  invalidEmail: "Пожалуйста, введите правильный email.",
  attachPassport: "Прикрепить паспорт",
  readAgreed: "Я прочитал и согласен с ",
  termsConditions: "Условиями использования",
  submit: "Отправить",
  telephone: "Телефон",
  address1: "Адрес: 2-3 Проспект Бунёдкор, здания CIU, 4-й этаж",
  address2: "Ташкент, Узбекистан 100043",
  submittedSucces: "Вы успешно отправили заявку с ",
  checkEmail:
    "Пожалуйста, проверьте свой email для получения дальнейших информации.",
  payNow: "ОПЛАТИТЬ СЕЙЧАС",
  contacts: "Контакты",
  results: "Результаты",
  examDates: "Даты экзаменов",
  whichTest: "За какой тест вы будете платить?",
  examDate: "Дата экзамена",
  examDateRequired: "Вы должны выбрать дату экзамена",
  examRegion: "Регион экзамена",
  paymentFor: "Оплата за",
  enterEnquiry: "Введите номер вашего запроса (EnquiryId)",
  next: "Далее",
  examDetails: "Детали экзамена",
  date: "Дата",
  region: "Регион",
  status: "Статус",
  examPrice: "Цена экзамена",
  processingFee: "Комиссия",
  totalPay: "Итого к оплате",
  price: "Цена",
  cardNo: "Номер карты",
  validThru: "Действительна до",
  phoneNo: "Номер телефона",
  enterCode: "Введите код из SMS",
  pay: "Оплатить",
  securePaymentTitle: "Безопасная обработка платежей:",
  securePayment1:
    "Ваша безопасность - наш приоритет. Мы не храним данные вашей карты. Все платежи безопасно обрабатываются через",
  securePayment2:
    "доверенный сервис третьей стороны. Наслаждайтесь спокойствием с шифрованием end-to-end и проверкой OTP для дополнительной безопасности.",
  receipt: {
    title: "Квитанция об оплате",
    info: `Центр тестирования ООО "Edu Action" подтверждает, что указанный кандидат успешно оплатил указанный тест и модуль:`,
    name: "Имя кандидата",
    idNo: "ID/Паспорт №",
    paymentDate: "Дата оплаты",
    paymentAmount: "Сумма оплаты",
    exam: "Экзамен",
    module: "Модуль",
    qrInfo: `QR-код является подтверждением вашего платежа.`,
  },
  selectProvider: "Выберите способ оплаты",
  codeSent: "Код отправлен на ",
  cvc: "CVV / CVC",
  cvcRequired: "Введите 3-значный код с обратной стороны карты",
  promocode: "Промокод",
  promocodePlaceholder: "Введите промокод",
  promocodeApply: "Применить",
  promocodeRemove: "Убрать",
  promocodeApplied: "Промокод применён",
  promocodeInvalid: "Этот промокод использовать нельзя",
  promocodeOff: "скидка",
  promocodeDiscount: "Скидка по промокоду",
  promocodeSelectModule: "Сначала выберите, за что вы платите",
  menu: "Меню",
  backToTop: "Наверх",
  paymentFailedTitle: "Платёж не прошёл",
  paymentFailedBody: "Платёж не был завершён. Проверьте данные карты и баланс и попробуйте ещё раз. Если деньги списались с карты, свяжитесь с нами.",
  tryAgain: "Попробовать ещё раз",
  needHelp: "Нужна помощь?",
  notFoundTitle: "Страница не найдена",
  notFoundBody: "Возможно, ссылка устарела или в ней опечатка.",
  goToPayment: "Перейти к оплате",
  loadingReceipt: "Загружаем квитанцию…",
  receiptNotFoundTitle: "Квитанция не найдена",
  receiptNotFoundBody: "Проверьте ссылку или QR-код. Если вы только что оплатили, подождите минуту и откройте ссылку снова.",
  loadFailed: "Не удалось загрузить квитанцию",
  loadFailedBody: "Проверьте подключение и попробуйте ещё раз.",
  print: "Печать",
  selectPlaceholder: "Выберите…",
  clear: "Очистить",
  intlCardTitle: "Международные карты (Visa, Mastercard)",
  invalidCardNumber: "Введите полный 16-значный номер карты.",
  invalidPhone9: "Введите 9-значный номер телефона, привязанный к карте.",
  otpRequired: "Введите код из SMS, отправленного на ваш телефон.",
  genericError: "Что-то пошло не так. Попробуйте ещё раз.",
  enquiryExpired: "Срок действия запроса истёк, оплатить его нельзя. Свяжитесь с нами, чтобы получить новый.",
  enquiryRequired: "Введите номер запроса.",
  enquiryNotFound: "Запрос с таким номером не найден. Проверьте номер и попробуйте ещё раз.",
  instructions: "Инструкция",
  checkAnotherEnquiry: "Проверить другой запрос",
  cardDetails: "Данные карты",
};

export default ru;
